module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.e18bbf6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/relayevent/font/glyphicons-halflings-regular.ttf
// module id = 6j22
// module chunks = 0